import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {withStyles} from "@material-ui/core";
import {PublicHeader} from "../../components"
import Login from "../../views/Login/Login"






class PublicLayout extends Component {


    render() {

        const { classes,Component,title,route } = this.props;
        return (
            <div style={{backgroundColor:"white",height:"100vh"}} className={classes.root}>
                <PublicHeader title={title}/>
                {Component?
                    <Component route={route}/>: <Login route={route}/>
                }
            </div>
        );
    }
}

const styles = {
    root: {
        flexGrow: 1
    }
}

export default withStyles(styles)(PublicLayout);





// WEBPACK FOOTER //
// ./src/layouts/Public/PublicLayout.jsx